module.exports = __webpack_public_path__ + "static/img/kjdy6.ee7dab7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/kjdy6.png
// module id = 341
// module chunks = 0